export default class BaseForm {
    constructor(FormValidator) {
        this._FormValidator = FormValidator;
        this._errors = {};
    }

    validate() {
        this._errors = new this._FormValidator(this).errors;
    }

    get isValid() {
        return Object.keys(this._errors).length === 0;
    }

    flattenErrors(field) {
        if (!this._errors[field]) return "";
        return this._errors[field].join("<br>");
    }

    get errors() {
        return this._errors;
    }

    set errors(val) {
        this._errors = val;
    }

    serialize() {
        const form = {};
        Object.keys(this).forEach(k => {
            if (!k.startsWith("_")) {
                form[k] = this[k];
            }
        });
        return form;
    }

}